import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import UniformPricingTiersTable, {
	type UniformPricingTiersTableProps,
} from '../../../../../../uniform/components/pricing-tiers-table/src/pricing-tiers-table.tsx';

const containerCss = css({
	marginBlockStart: token('space.100'),
	marginBlockEnd: token('space.100'),
});

export interface EmbeddedPricingTiersTableProps {
	data: unknown;
}

export const EmbeddedPricingTiersTable = (props: EmbeddedPricingTiersTableProps) => {
	const { data } = props;
	return (
		<div css={containerCss}>
			<UniformPricingTiersTable {...(data as UniformPricingTiersTableProps)} />
		</div>
	);
};
